import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePasswordReset } from '../../hooks/usePasswordReset';
import './ForgotPasswordForm.scss';

interface ForgotPasswordFormProps {
  onBackToLogin: () => void;
}

export const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({ onBackToLogin }) => {
  const { t } = useTranslation('auth');
  const [username, setUsername] = useState('');
  const { handleForgotPassword, isLoading, error } = usePasswordReset();
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUsername(e.target.value);
  };

  const isFormValid = username.length >= 3;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!username) {
      return;
    }

    try {
      await handleForgotPassword(username);
      setIsSubmitted(true);
    } catch (err) {
      // Error is handled by the hook
    }
  };

  return (
    <div className="forgot-password-form-container">
      <h2>{t('forgotPasswordForm.title')}</h2>     
      {!isSubmitted ? (
        <>
          <p className="instruction-text">
            {t('forgotPasswordForm.instruction')}
          </p>
          
          <form className="forgot-password-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="username">{t('forgotPasswordForm.username')}</label>
              <input
                type="text"
                id="username"
                name="username"
                value={username}
                onChange={handleChange}
                disabled={isLoading}
                placeholder={t('forgotPasswordForm.usernamePlaceholder')}
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button
              type="submit"
              className={`send-button ${isFormValid ? 'valid' : ''}`}
              disabled={isLoading || !isFormValid}
            >
              {isLoading
                ? t('forgotPasswordForm.sending')
                : t('forgotPasswordForm.send')}
            </button>
            
            <div className="back-to-login">
              <button 
                type="button" 
                className="back-link" 
                onClick={onBackToLogin}
              >
                {t('forgotPasswordForm.backTo')} <span className="login-text" dangerouslySetInnerHTML={{ __html: t('forgotPasswordForm.backToLogin') }}></span>
              </button>
            </div>
          </form>
        </>
      ) : (
        <div className="success-message">
          {/* <h3>{t('forgotPasswordForm.successTitle')}</h3> */}
          <p>{t('forgotPasswordForm.successMessage')}</p>
          <button
            className="login-button"
            onClick={onBackToLogin}
          >
            {t('forgotPasswordForm.backToLogin')}
          </button>
        </div>
      )}
    </div>
  );
};
